import { render, staticRenderFns } from "./bouserlist.vue?vue&type=template&id=603c1c8d&scoped=true"
import script from "./bouserlist.vue?vue&type=script&lang=js"
export * from "./bouserlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603c1c8d",
  null
  
)

export default component.exports